import { render, staticRenderFns } from "./SelectType.vue?vue&type=template&id=9a4dcb70&scoped=true"
import script from "./SelectType.vue?vue&type=script&lang=js"
export * from "./SelectType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a4dcb70",
  null
  
)

export default component.exports